import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { PAGE_SIZE_OPTIONS } from '../../../constant'
import {
  changeFilter,
  selectFilterTableFilterCompany,
  selectTotalRecords,
} from '../store/slice'
import { Pagination } from './../../../../common/pagination'

export const PaginationTableFilterCompanies = () => {
  const dispatch = useDispatch()

  const { page, pageSize } = useSelector(selectFilterTableFilterCompany())
  const totalRecords = useSelector(selectTotalRecords)

  const handleSetPage = (value) => {
    dispatch(
      changeFilter({
        page: value,
      }),
    )
  }

  const setPageSize = (value) => {
    dispatch(
      changeFilter({
        pageSize: value,
        page: 1,
      }),
    )
  }

  return (
    <div style={{ paddingTop: 12 }}>
      <Pagination
        page={page}
        pageSize={pageSize}
        total={totalRecords}
        setPage={handleSetPage}
        setPageSize={setPageSize}
        pageSizeOptions={PAGE_SIZE_OPTIONS}
      />
    </div>
  )
}
